// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3zLa_","header":"PatientBlock_header__2-U9b","label":"PatientBlock_label__1W0S5","option":"PatientBlock_option__rIU-t"};